$(document).ready(function() {
  if(!document.querySelector('.tabs-privacy')) return false;

  var multiTab = {
    obj : null, 
    tab : null,

    init : function(){
      obj = $('.multiTab');
      tab = obj.find('.btn-tab');

      this.event();
    },

    event : function(){
      tab.off().on('click', function(e){
        e.preventDefault();
        $(this).addClass('active').attr('aria-selected','true').parent().siblings().children().removeClass('active').attr('aria-selected','false');
        $(this.hash).addClass('active').siblings().removeClass('active');
      });
  
      // BTOBGLOBAL-212 start
      // cf) ~/global/business/eu/privacy?#directMarketing
      var url = window.location.href;
      var tabParam = url.substr(url.indexOf("?") + 1);
      
      if(url.indexOf("?") != -1){
        switch (tabParam) {
          case '#directMarketing' :
            $('a.btn-tab[href="#directMarketing"]').trigger('click');
          break
          case '#transferOutside' :
            $('a.btn-tab[href="#transferOutside"]').trigger('click');
          break
        }

        if($(document).width() < 620) { // mobile :: scroll positioning of target tab 
          var targetPos = $('a.btn-tab[href="' + tabParam + '"]').position().left;
          $('.tabs-type-liner').animate({scrollLeft: targetPos + 'px'},200);
        }
      }
      // BTOBGLOBAL-212 end

    }

  };
  multiTab.init();
  
});

